import SearchEvents from "./SearchEvents";
import {AggregationType, SearchResult} from "./SearchResult";
import {ActiveFacetSet} from "./SearchReducer";

export const search = (userId: string, query: string, targets: string[], filters?: ActiveFacetSet) => ({
    type: SearchEvents.SearchStarted,
    userId, query, targets, filters
} as const);

export const searchComplete = (result: SearchResult) => ({
    type: SearchEvents.SearchCompleted,
    result
} as const);

export const unselectFacet = (facetType: AggregationType, facet: string) => ({
    type: SearchEvents.UnselectFacet,
    facetType, facet
} as const);

export const selectFacet = (facetType: AggregationType, facet: string) => ({
    type: SearchEvents.SelectFacet,
    facetType, facet
} as const);

export const resetSearchResult = () => ({
    type: SearchEvents.ClearSearchResult
} as const);
